<template>
  <!-- 弹出框 -->
  <a-modal
    v-model="modal.visible"
    :title="modal.title"
    @ok="handleOk"
    @cancel="cancel"
    :confirm-loading="confirmLoading"
  >
    <a-form-model
      ref="ruleForm"
      :model="formData"
      :rules="rules"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 20 }"
    >
      <a-form-model-item label="商户名称"
        ><a-input v-model="formData.merchantName" disabled
      /></a-form-model-item>
      <a-form-model-item label="模板标题"
        ><a-input v-model="formData.templateTitle" disabled
      /></a-form-model-item>
      <a-form-model-item label="模板id"
        ><a-input v-model="formData.templateId" :maxLength="32" disabled
      /></a-form-model-item>
      <a-form-model-item label="模板描述"
        ><a-input v-model="formData.description" type="textarea"
      /></a-form-model-item>
      <a-form-model-item label="排序" prop="listOrder">
        <a-input-number v-model="formData.listOrder" :min="1" :max="99999" />
      </a-form-model-item>
      <a-row>
        <a-col :span="12">
          <a-form-model-item
            label="是否默认"
            :label-col="{ span: 8 }"
            :wrapper-col="{ span: 12 }"
          >
            <a-switch
              checked-children="是"
              un-checked-children="否"
              :checked="formData.isDefault == 'T' ? true : false"
              @change="onChange('isDefault')"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  name: "TemplateInfo",
  data() {
    return {
      confirmLoading: false,
      //弹出框参数
      modal: {
        visible: false,
        title: "",
        type: "add"
      },
      //form
      formData: {
        merchantName: "",
        templateId: "",
        templateTitle: "",
        description: "",
        isHalt: "F",
        listOrder: 1,
        isDefault: "F"
      },
      //form rules
      rules: {}
    };
  },
  created() {},
  methods: {
    showModal(type, data) {
      this.modal.visible = true;
      this.modal.title = type == "add" ? "添加模板" : "编辑编辑";
      this.modal.type = type;
      if (data && type == "edit") {
        this.formData = Object.assign({}, data);
      }
    },
    onChange(column) {
      if (this.formData[column] == "T") {
        this.formData[column] = "F";
      } else {
        this.formData[column] = "T";
      }
    },
    cancel() {
      this.formData = {
        merchantName: "",
        templateId: "",
        templateTitle: "",
        description: "",
        isHalt: "F",
        listOrder: 1,
        isDefault: "F"
      };
      this.confirmLoading = false;
      this.$refs.ruleForm.resetFields();
      this.modal.visible = false;
    },
    /**
     * 保存
     */
    handleOk() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let param = Object.assign({}, this.formData);
          this.confirmLoading = true;
          let action = "modifyMerchantContractTemplate";
          this.$http.roomBksApi[action](param)
            .then(res => {
              if (res.result == 0) {
                this.cancel();
                this.$emit("success");
                this.$message.success(res.msg);
              }
            })
            .finally(() => {
              this.confirmLoading = false;
            });
        }
      });
    }
  }
};
</script>

<style></style>
